<div id="selectableText"
     (mouseenter)="onMouseEnterSelectableText()"
     (mouseleave)="onMouseLeaveSelectableText()"
     [innerHtml]="text | safe"></div>
